import React from 'react';
import PropTypes from 'prop-types';

import styles from './playersList.scss';

// Row note indicator (185-11717): the design-system note glyph (public/img/v3/icons/icon-note.svg),
// tinted the interaction blue and made clickable so it re-opens the note modal in edit mode. Inlined
// with stroke="currentColor" so the blue comes from the stylesheet token rather than a second asset.
const NoteIndicator = ({ onClick, 'data-testid': dataTestId }) => (
    <button
        type="button"
        className={styles.noteIcon}
        onClick={onClick}
        aria-label="Edit player note"
        data-testid={dataTestId || undefined}
    >
        <svg width="14" height="16" viewBox="1 4 12 14" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect x="1.5" y="4.5" width="11" height="13" rx="1.5" stroke="currentColor" />
            <line x1="4.5" y1="7.5" x2="9.5" y2="7.5" stroke="currentColor" strokeLinecap="round" />
            <line x1="4.5" y1="10.5" x2="9.5" y2="10.5" stroke="currentColor" strokeLinecap="round" />
            <line x1="4.5" y1="13.5" x2="7.5" y2="13.5" stroke="currentColor" strokeLinecap="round" />
        </svg>
    </button>
);

NoteIndicator.propTypes = {
    onClick: PropTypes.func,
    'data-testid': PropTypes.string,
};

NoteIndicator.defaultProps = {
    onClick: () => {},
    'data-testid': null,
};

export default NoteIndicator;
